import { css } from "../../css/util.compose-css";

export const dialog = css`
  margin: 0;
  padding: 0;

  height: auto;
  width: auto;

  border: none;
`;
